export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  coverImage: string;
  chapters: ComicChapter[];
  views: number;
  updateDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const CATEGORIES = [
  { key: 'all', label: '全部' },
  { key: '恋爱', label: '恋爱' },
  { key: '奇幻', label: '奇幻' },
  { key: '动作', label: '动作' },
  { key: '悬疑', label: '悬疑' },
  { key: '喜剧', label: '喜剧' },
  { key: '都市', label: '都市' },
  { key: '校园', label: '校园' },
  { key: '穿越', label: '穿越' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '月光下的秘密',
    author: '金秀雅',
    category: '恋爱',
    status: '连载中',
    rating: 9.5,
    description: '在首尔繁华的都市夜晚，两个素不相识的灵魂因一次偶然的相遇而交织在一起。她是一名平凡的花艺师，他是顶级娱乐公司的王牌制作人。月光见证了他们的初遇，也将在未来的每一个夜晚守护这份来之不易的爱情。当命运的红线将两人紧紧相连，隐藏在各自背后的秘密也逐渐浮出水面...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20beautiful%20couple%20under%20moonlight%20in%20Seoul%20city%20night%2C%20soft%20watercolor%20illustration%20style%2C%20warm%20romantic%20atmosphere%2C%20elegant%20Korean%20manhwa%20aesthetic%2C%20delicate%20lines%2C%20dreamy%20moonlight%20glow%2C%20clean%20simple%20background%20with%20warm%20cream%20tone&width=800&height=1200&seq=comic-cover-01&orientation=portrait',
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 15)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1285000,
    updateDate: '2026-08-03',
    tags: ['纯爱', '都市', '职场'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '异世界剑圣',
    author: '李东旭',
    category: '奇幻',
    status: '连载中',
    rating: 9.7,
    description: '平凡的高中生韩宇在一次意外中穿越到了充满魔法与剑术的异世界。在这里，他意外发现自己拥有传说中的"剑圣之血"，成为了拯救这个濒临崩溃世界的关键。随着力量的觉醒，他逐渐揭开了异世界背后隐藏的惊天阴谋。一场关于勇气、友情与成长的史诗冒险，就此展开...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20heroic%20swordsman%20with%20glowing%20sword%20in%20magical%20world%2C%20epic%20adventure%20illustration%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20coral%20tones%2C%20Korean%20webtoon%20style%2C%20clean%20simple%20composition&width=800&height=1200&seq=comic-cover-02&orientation=portrait',
    chapters: Array.from({ length: 62 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 20)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2350000,
    updateDate: '2026-08-03',
    tags: ['热血', '冒险', '成长'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴志勋',
    category: '动作',
    status: '连载中',
    rating: 9.3,
    description: '前特种部队成员金泰浩退役后成为了一名私家侦探。首尔繁华的表象下，隐藏着不为人知的黑暗面。一个看似普通的失踪案件，却将他卷入了一场跨越整个东亚的巨大阴谋。为了真相，他必须在暗夜中与时间赛跑，用自己的方式伸张正义...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20intense%20male%20detective%20in%20dark%20alley%20at%20night%2C%20noir%20style%20illustration%2C%20dramatic%20shadows%2C%20warm%20amber%20street%20light%2C%20Korean%20webtoon%20aesthetic%2C%20clean%20composition%20with%20mysterious%20atmosphere&width=800&height=1200&seq=comic-cover-03&orientation=portrait',
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 13)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1890000,
    updateDate: '2026-08-02',
    tags: ['悬疑', '犯罪', '都市'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '第七感',
    author: '崔恩珠',
    category: '悬疑',
    status: '已完结',
    rating: 9.6,
    description: '拥有预知能力的少女林素希，每次做梦都能看到即将发生的犯罪事件。她与刑警姜河镇联手，利用自己的特殊能力阻止了一桩又一桩的悲剧。然而，当她的预知能力指向了自己最亲近的人时，一切都变得复杂起来。真相与谎言的边界在哪里？相信自己的超能力，还是相信眼前的人？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20young%20woman%20with%20mysterious%20eyes%20and%20prophetic%20visions%2C%20psychological%20thriller%20illustration%2C%20surreal%20atmosphere%2C%20warm%20dark%20tones%2C%20Korean%20webtoon%20style%2C%20intriguing%20composition&width=800&height=1200&seq=comic-cover-04&orientation=portrait',
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(6 - Math.floor(i / 19)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 3120000,
    updateDate: '2026-06-15',
    tags: ['超能力', '推理', '犯罪'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '社内恋爱禁止令',
    author: '郑美妍',
    category: '喜剧',
    status: '连载中',
    rating: 9.1,
    description: '韩国最大游戏公司"NexGen"有一条不成文的规定：禁止办公室恋爱。然而，当新来的萌系策划师朴多美遇上了高冷程序员组长车贤宇，两人在工作中的每一次碰撞都擦出了意想不到的火花。面对同事的八卦、上司的怀疑和内心的挣扎，一场啼笑皆非的社内恋爱喜剧就此上演！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20funny%20office%20romance%20scene%20with%20cute%20couple%20expression%2C%20bright%20playful%20illustration%2C%20warm%20cheerful%20colors%2C%20chibi%20elements%2C%20Korean%20webtoon%20style%2C%20clean%20simple%20composition&width=800&height=1200&seq=comic-cover-05&orientation=portrait',
    chapters: Array.from({ length: 32 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 11)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1560000,
    updateDate: '2026-08-01',
    tags: ['办公室', '恋爱', '搞笑'],
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: '江南夜未眠',
    author: '吴贤宇',
    category: '都市',
    status: '连载中',
    rating: 9.4,
    description: '江南区的夜晚从不眠。在这片首尔最繁华的土地上，每个人都有着不为人知的故事。从底层的便利店店员到顶层的财阀继承人，命运将六个不同阶层的人紧紧联系在一起。在金钱、欲望和梦想交织的江南夜晚，谁能够守住最初的真心？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20drama%20cover%20art%2C%20Seoul%20Gangnam%20night%20cityscape%20with%20diverse%20characters%2C%20modern%20lifestyle%20illustration%2C%20warm%20neon%20and%20amber%20tones%2C%20sophisticated%20Korean%20webtoon%20style%2C%20clean%20composition&width=800&height=1200&seq=comic-cover-06&orientation=portrait',
    chapters: Array.from({ length: 41 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 14)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1780000,
    updateDate: '2026-08-02',
    tags: ['群像', '社会', '情感'],
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: '放学后的秘密基地',
    author: '金智恩',
    category: '校园',
    status: '连载中',
    rating: 9.2,
    description: '高二学生李星河在学校的旧图书馆发现了一间被遗忘的阁楼，这里成为了他和朋友们的秘密基地。在这里，他们分享彼此的烦恼与梦想，见证着彼此的成长。当青春的热血遇上现实的考验，这个秘密基地承载了太多无法言说的心情。这是一段关于青春、友情和懵懂初恋的温暖故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%20art%2C%20group%20of%20high%20school%20friends%20in%20cozy%20library%20attic%2C%20warm%20youthful%20illustration%2C%20soft%20sunlight%20filtering%20through%20window%2C%20Korean%20webtoon%20style%2C%20nostalgic%20atmosphere%2C%20clean%20composition&width=800&height=1200&seq=comic-cover-07&orientation=portrait',
    chapters: Array.from({ length: 28 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 10)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 980000,
    updateDate: '2026-08-03',
    tags: ['青春', '友情', '成长'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '穿越成反派大小姐',
    author: '尹素拉',
    category: '穿越',
    status: '连载中',
    rating: 9.0,
    description: '普通上班族韩智恩一觉醒来，发现自己穿越进了最喜欢的恋爱小说中——而且成为了注定悲剧的反派大小姐！为了改变既定的悲惨命运，她决定用自己的方式来改写故事。然而，当她逐渐改变了原著剧情，原本应该爱上女主角的男主角们却纷纷被她吸引。这到底是命运的玩笑，还是她自己的选择？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20isekai%20cover%20art%2C%20elegant%20noble%20lady%20in%20European%20style%20dress%20with%20magical%20elements%2C%20fantasy%20romance%20illustration%2C%20warm%20regal%20tones%2C%20Korean%20webtoon%20style%2C%20beautiful%20detailed%20composition&width=800&height=1200&seq=comic-cover-08&orientation=portrait',
    chapters: Array.from({ length: 35 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 12)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1450000,
    updateDate: '2026-08-03',
    tags: ['逆袭', '恋爱', '搞笑'],
    isHot: true,
    isNew: false,
  },
  {
    id: 9,
    title: '樱桃味的初吻',
    author: '宋艺琳',
    category: '恋爱',
    status: '已完结',
    rating: 9.3,
    description: '从小到大都是优等生的安多允，在大学毕业前的最后一个夏天，遇到了完全不是她理想型的街头艺人尹在赫。他随性自由的生活方式与她的严谨规划形成了鲜明对比。然而正是这个夏天，一场意外的吻改变了一切。樱桃味的初吻，成为了她人生中最甜蜜的回忆...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20sweet%20summer%20love%20scene%20with%20cherry%20blossoms%2C%20young%20couple%20under%20tree%2C%20soft%20pink%20and%20cream%20tones%2C%20romantic%20watercolor%20illustration%2C%20Korean%20webtoon%20style%2C%20dreamy%20composition&width=800&height=1200&seq=comic-cover-09&orientation=portrait',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(5 - Math.floor(i / 16)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2100000,
    updateDate: '2026-05-20',
    tags: ['青春', '纯爱', '音乐'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '龙之契约',
    author: '韩在民',
    category: '奇幻',
    status: '连载中',
    rating: 9.5,
    description: '在人类与龙族共存的世界里，少年李天宇意外与一条古老的火龙签订了契约。从此，他拥有了驾驭火焰的能力，但也背负上了保护龙族血脉的使命。当黑暗势力企图打破两族之间的平衡，李天宇必须做出选择：是守护人类的和平，还是履行与龙的约定？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20young%20hero%20with%20fire%20dragon%20companion%2C%20epic%20magical%20battle%20illustration%2C%20warm%20golden%20fire%20and%20coral%20glow%2C%20Korean%20webtoon%20style%2C%20dynamic%20composition&width=800&height=1200&seq=comic-cover-10&orientation=portrait',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 18)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1980000,
    updateDate: '2026-08-01',
    tags: ['龙', '冒险', '契约'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '搏击俱乐部',
    author: '张泰民',
    category: '动作',
    status: '已完结',
    rating: 9.4,
    description: '曾被誉为"地下拳王"的李俊浩，为了给妹妹筹集医药费而重回搏击赛场。在这个充满暴力与金钱的地下世界，每一场比赛都关乎生死。然而，当他发现妹妹的病情与一个庞大的犯罪组织有关时，他的拳头不再只是为了金钱，更是为了正义与救赎...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20intense%20fighter%20in%20underground%20ring%2C%20dynamic%20martial%20arts%20illustration%2C%20warm%20dramatic%20lighting%2C%20strong%20contrast%2C%20Korean%20webtoon%20style%2C%20powerful%20composition&width=800&height=1200&seq=comic-cover-11&orientation=portrait',
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(4 - Math.floor(i / 20)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2670000,
    updateDate: '2026-04-28',
    tags: ['格斗', '犯罪', '亲情'],
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '失踪的第八天',
    author: '赵敏瑞',
    category: '悬疑',
    status: '连载中',
    rating: 9.5,
    description: '首尔市中心一家高级酒店的客人在入住后第八天神秘失踪。刑警沈智浩接手调查后，发现这并非个案——过去三年里，已有七人在不同酒店以同样的方式消失。所有的线索指向了一个名为"第八天"的暗网组织。当沈智浩深入调查时，他发现自己也正在成为下一个目标...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20mysterious%20hotel%20corridor%20with%20detective%20silhouette%2C%20dark%20psychological%20suspense%20illustration%2C%20warm%20dim%20amber%20lighting%2C%20Korean%20webtoon%20style%2C%20tense%20composition&width=800&height=1200&seq=comic-cover-12&orientation=portrait',
    chapters: Array.from({ length: 29 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 10)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1340000,
    updateDate: '2026-08-03',
    tags: ['推理', '暗网', '犯罪'],
    isHot: false,
    isNew: true,
  },
  {
    id: 13,
    title: '便利店打工日记',
    author: '权娜拉',
    category: '喜剧',
    status: '连载中',
    rating: 8.9,
    description: '大学生金多彬为了赚取生活费，开始在24小时便利店打工。在这里，她遇到了形形色色的顾客：深夜买泡面的加班族、总是忘记带钱的老奶奶、神秘兮兮的畅销书作家...每一个深夜来便利店的人，都有着自己独特的故事。而金多彬的便利店日记，记录了所有这些温暖的瞬间。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cute%20convenience%20store%20worker%20with%20colorful%20snacks%2C%20warm%20cozy%20illustration%2C%20bright%20cheerful%20colors%2C%20Korean%20webtoon%20style%2C%20pleasant%20composition&width=800&height=1200&seq=comic-cover-13&orientation=portrait',
    chapters: Array.from({ length: 24 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 8)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 870000,
    updateDate: '2026-08-02',
    tags: ['日常', '治愈', '搞笑'],
    isHot: false,
    isNew: true,
  },
  {
    id: 14,
    title: '摩天大楼',
    author: '崔秀贤',
    category: '都市',
    status: '已完结',
    rating: 9.7,
    description: '韩国第一高楼"天空之城"是权力与财富的象征。在这座108层的摩天大楼里，每一层都上演着不同的人生：顶层的财阀家族、中层的精英白领、底层的服务人员。当一场突如其来的火灾席卷大楼，所有人的命运在那一刻被彻底改变。生存与道德的抉择，考验着每个人的灵魂。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20towering%20skyscraper%20in%20Seoul%20city%2C%20intense%20survival%20drama%20illustration%2C%20warm%20urban%20tones%20with%20dramatic%20contrast%2C%20Korean%20webtoon%20style%2C%20cinematic%20composition&width=800&height=1200&seq=comic-cover-14&orientation=portrait',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(3 - Math.floor(i / 24)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 3450000,
    updateDate: '2026-03-30',
    tags: ['灾难', '人性', '社会'],
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    title: '学霸的恋爱方程式',
    author: '文智慧',
    category: '校园',
    status: '已完结',
    rating: 9.1,
    description: '全校第一的学霸姜书妍，人生中唯一不懂的事情就是恋爱。当学校最受欢迎的篮球队员金道允向她表白时，她决定用自己最擅长的方式——数学公式，来解决恋爱这个难题。然而，感情真的可以用公式来计算吗？一段充满笑与泪的校园恋爱实验就此开始...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%2C%20smart%20girl%20and%20popular%20boy%20in%20classroom%2C%20cute%20youthful%20illustration%2C%20warm%20soft%20sunlight%2C%20Korean%20webtoon%20style%2C%20sweet%20composition&width=800&height=1200&seq=comic-cover-15&orientation=portrait',
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(7 - Math.floor(i / 14)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1650000,
    updateDate: '2026-07-18',
    tags: ['学霸', '篮球', '青春'],
    isHot: false,
    isNew: false,
  },
  {
    id: 16,
    title: '王妃的重生',
    author: '姜艺书',
    category: '穿越',
    status: '连载中',
    rating: 9.4,
    description: '大韩帝国的末代王妃李素媛在亡国之日饮毒自尽，却意外重生回到了十年前——还未入宫的少女时代。带着前世的记忆，她决心不再重复命运的轨迹。然而，历史的车轮是否真的能够被改变？当她与曾经深爱的君主再次相遇，一切似乎又回到了原点...',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20fantasy%20cover%20art%2C%20elegant%20princess%20in%20traditional%20Korean%20hanbok%2C%20palace%20background%2C%20gorgeous%20detailed%20illustration%2C%20warm%20regal%20tones%2C%20Korean%20webtoon%20style%2C%20beautiful%20composition&width=800&height=1200&seq=comic-cover-16&orientation=portrait',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 12)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1820000,
    updateDate: '2026-08-02',
    tags: ['重生', '宫斗', '逆袭'],
    isHot: true,
    isNew: false,
  },
  {
    id: 17,
    title: '心跳的旋律',
    author: '韩素希',
    category: '恋爱',
    status: '连载中',
    rating: 9.2,
    description: '失聪的钢琴天才南智雅，用触觉和心跳感受音乐的律动。当她在一次比赛中遇见了同样热爱音乐的小提琴手郑载熙，两个灵魂因音乐而共振。然而，智雅的听力障碍成为了两人之间最大的阻碍。在音乐与爱情之间，他们能否找到属于自己的旋律？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20music%20romance%20cover%20art%2C%20beautiful%20pianist%20girl%20and%20violinist%20boy%20in%20concert%20hall%2C%20elegant%20musical%20illustration%2C%20warm%20golden%20stage%20light%2C%20Korean%20webtoon%20style%2C%20romantic%20composition&width=800&height=1200&seq=comic-cover-17&orientation=portrait',
    chapters: Array.from({ length: 33 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 11)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1120000,
    updateDate: '2026-08-03',
    tags: ['音乐', '治愈', '纯爱'],
    isHot: false,
    isNew: true,
  },
  {
    id: 18,
    title: '神域的末裔',
    author: '白允浩',
    category: '奇幻',
    status: '连载中',
    rating: 9.6,
    description: '神域崩塌之后，众神的后裔散落在人间。少年郑信偶然发现自己体内流淌着太阳神的后裔之血，他必须收集散落的神器碎片，重建通往神域的通道。然而，随着力量的觉醒，他逐渐发现神域的崩塌并非天灾，而是一场精心策划的阴谋。诸神的黄昏，将由他来改写。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mythological%20fantasy%20cover%20art%2C%20young%20demigod%20with%20divine%20golden%20light%2C%20epic%20mythological%20illustration%2C%20warm%20radiant%20tones%2C%20Korean%20webtoon%20style%2C%20majestic%20composition&width=800&height=1200&seq=comic-cover-18&orientation=portrait',
    chapters: Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 17)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2080000,
    updateDate: '2026-08-01',
    tags: ['神话', '热血', '冒险'],
    isHot: true,
    isNew: false,
  },
  {
    id: 19,
    title: '笑傲江湖之韩国篇',
    author: '金武英',
    category: '动作',
    status: '连载中',
    rating: 9.0,
    description: '改编自经典武侠的现代韩国版。年轻武术家柳贤继承了家族的古老武学秘籍，在现代都市中行侠仗义。当传统武术遇上现代黑帮，当东方哲学碰撞韩国现实，一段充满热血与正义的现代武侠传奇就此展开。拳拳到肉的格斗场面，蕴含着深刻的武道精神。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%20art%2C%20modern%20martial%20artist%20in%20urban%20setting%2C%20dynamic%20action%20illustration%2C%20warm%20energetic%20tones%2C%20Korean%20webtoon%20style%2C%20powerful%20composition&width=800&height=1200&seq=comic-cover-19&orientation=portrait',
    chapters: Array.from({ length: 44 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(8 - Math.floor(i / 15)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1560000,
    updateDate: '2026-08-02',
    tags: ['武侠', '现代', '格斗'],
    isHot: false,
    isNew: false,
  },
  {
    id: 20,
    title: '猫的报恩',
    author: '刘智雅',
    category: '喜剧',
    status: '已完结',
    rating: 9.3,
    description: '平凡上班族金敏俊某天救了一只流浪猫，没想到这只猫竟然是猫国的王子！为了报答救命之恩，猫王子决定帮助金敏俊实现三个愿望。然而，猫王子的"帮助"总是以最意想不到的方式展现，让金敏俊的生活变得一团糟又充满了欢乐。一段人猫之间的奇妙缘分就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comedy%20cover%20art%2C%20cute%20magical%20cat%20and%20ordinary%20office%20worker%2C%20whimsical%20funny%20illustration%2C%20warm%20cheerful%20colors%2C%20Korean%20webtoon%20style%2C%20playful%20composition&width=800&height=1200&seq=comic-cover-20&orientation=portrait',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      updateDate: `2026-0${String(7 - Math.floor(i / 12)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1230000,
    updateDate: '2026-07-25',
    tags: ['动物', '奇幻', '治愈'],
    isHot: false,
    isNew: false,
  },
];

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getComicsByCategory = (category: string): Comic[] => {
  if (category === 'all') return comics;
  return comics.filter((c) => c.category === category);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return comics.filter((c) => c.isHot).slice(0, limit);
};

export const getNewComics = (limit: number = 8): Comic[] => {
  return comics.filter((c) => c.isNew).slice(0, limit);
};

export const getRelatedComics = (comic: Comic, limit: number = 6): Comic[] => {
  return comics
    .filter((c) => c.id !== comic.id && c.category === comic.category)
    .slice(0, limit);
};

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
};